<template>
  <div v-if="groups.length" class="integration-menu-validation-list">
    <section
      v-for="(group, index) in groups"
      :key="'menu-validation-group-' + index + '-' + String(group.code || group.label)"
      class="integration-menu-validation-list__group"
    >
      <h6 class="integration-menu-validation-list__title">{{ groupTitle(group) }}</h6>
      <ul class="integration-menu-validation-list__items">
        <li
          v-for="(entry, itemIdx) in groupEntries(group)"
          :key="'menu-validation-item-' + index + '-' + itemIdx"
          class="integration-menu-validation-list__item"
        >
          <span class="integration-menu-validation-list__text">{{ entry.text }}</span>
          <button
            v-if="entry.editTarget"
            type="button"
            class="btn btn-info btn-sm integration-menu-validation-list__edit"
            :title="$t('gestiune.integrationsMenuValidationEditEntityHint')"
            @click="onEditClick(entry.editTarget)"
          >
            {{ $t('gestiune.integrationsMenuValidationEditEntity') }}
          </button>
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
import { getMenuValidationGroupEntries } from 'src/components/Dashboard/Views/Integrations/integrationMenuValidationHelpers.js'

export default {
  name: 'IntegrationMenuValidationCollapse',
  props: {
    groups: {
      type: Array,
      default: () => []
    },
    onEditEntry: {
      type: Function,
      default: null
    }
  },
  methods: {
    groupTitle (group) {
      const count = this.groupEntries(group).length
      return `${group.label} (${count})`
    },
    groupEntries (group) {
      return getMenuValidationGroupEntries(group, (key) => this.$t(key))
    },
    onEditClick (editTarget) {
      if (typeof this.onEditEntry === 'function') {
        this.onEditEntry(editTarget)
      }
    }
  }
}
</script>

<style scoped>
.integration-menu-validation-list__group + .integration-menu-validation-list__group {
  margin-top: 14px;
}
.integration-menu-validation-list__title {
  margin: 0 0 8px;
  font-size: 14px;
  font-weight: 600;
  color: #c62828;
}
.integration-menu-validation-list__items {
  margin: 0;
  padding: 0;
  list-style: none;
}
.integration-menu-validation-list__item {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 10px;
  border: 1px solid #e8eaf6;
  border-radius: 6px;
  background: #fafbff;
}
.integration-menu-validation-list__item + .integration-menu-validation-list__item {
  margin-top: 6px;
}
.integration-menu-validation-list__text {
  flex: 1;
  min-width: 0;
  font-size: 12px;
  line-height: 1.45;
  white-space: pre-wrap;
  word-break: break-word;
}
.integration-menu-validation-list__edit {
  flex-shrink: 0;
  margin: 0;
  padding: 4px 10px;
  font-size: 11px;
  line-height: 1.3;
  text-transform: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Integrations/IntegrationMenuValidationCollapse.vue